module.exports = __webpack_public_path__ + "static/media/4_Moderate.5b07aba6.svg";